import { useAuth } from "@/context/AuthContext";
import { startLogin } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Lock, Ban } from "lucide-react";

export const Spinner = () => (
  <div className="grid min-h-[50vh] place-items-center" data-testid="page-loading">
    <Loader2 className="h-7 w-7 animate-spin text-primary" />
  </div>
);

export const Notice = ({ icon: Icon, title, children, testid }) => (
  <div className="mx-auto mt-20 max-w-md rounded-3xl border bg-white p-10 text-center" data-testid={testid}>
    <Icon className="mx-auto mb-4 h-8 w-8 text-primary" />
    <h2 className="mb-2 text-2xl font-semibold">{title}</h2>
    {children}
  </div>
);

export default function RequireAuth({ children, admin }) {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user)
    return (
      <Notice icon={Lock} title="Sign in to continue" testid="auth-required">
        <p className="mb-6 text-stone-600">One click with your Google account.</p>
        <Button data-testid="auth-required-signin-button" className="rounded-full" onClick={startLogin}>Sign in with Google</Button>
      </Notice>
    );
  if (user.suspended)
    return (
      <Notice icon={Ban} title="Account suspended" testid="account-suspended">
        <p className="text-stone-600">Your account has been suspended by the FairStay team.</p>
      </Notice>
    );
  if (admin && !user.is_admin)
    return (
      <Notice icon={Lock} title="Admins only" testid="admin-only">
        <p className="text-stone-600">This area is for the FairStay team.</p>
      </Notice>
    );
  return children;
}
